(function () {'use strict';}());

angular.module('app')
  .controller('MemoryController', function ($scope,$q,$document,$filter,$timeout,AppService,$rootScope) {
  	var trace = angular.trace;

  	$scope.$watch("currentMinigame",onMinigameSelection);
    $scope.cards = null;
    $scope.maxAttempts = 0;
    $scope.numAttempts = 0;
    $scope.MEMORY_DELAY = 3000;
    $scope.checking = false;

    $scope.toggleCard = function(card){
      if(card.selected || card.complete || $scope.checking) return;
      card.selected = !card.selected;
      if(card.selected) $rootScope.$emit("audio","Flip_Card");
      checkMatch(card);
      checkCompletion();

    };


    function checkMatch(card){
      var selections = $filter('memory')($scope.cards,"match",card);
      if(selections.length < 2) return null;

      var card1 = selections[0];
      var card2 = selections[1];
      var correct = card1.answer === card2.answer;

      if(correct) $rootScope.$emit("audio","Correct_Location");

      if(correct) card1.complete = card2.complete = true;
      else
      {
        $scope.checking = true;
        $timeout(function(){
          card1.selected = card2.selected = false;
          $scope.checking = false;
          $scope.maxAttempts --;
          $scope.numAttempts ++;
          $scope.updateTelepathy($scope.numAttempts);
          $rootScope.$emit("audio","Losing_Psychic_Power");
          checkOver();
        }, $scope.MEMORY_DELAY);
      }

      return correct;
    }

    function checkOver(){
      if($scope.maxAttempts === 0){
        var deferred = $q.defer();
        var resetCallback;

        

        deferred.promise.then(returnToMenu);
        $scope.currentLocation.isCorrect = false;
        $rootScope.$emit("audio","Lose_Game");
        var evt = {
              eventCategory: "GRTT: Mini Game",
              eventLabel:  "GRTT: " + $scope.currentMinigame.title
          };
        gtag("event", "GRTT: end - incomplete", evt);

        $scope.drawDownHours(4);
        if($scope.hoursRemaining >= 4){
          resetCallback = $q.defer();
          resetCallback.promise.then(reset);
        }
        $scope.setCurrentFeedback("current feedback object",deferred,resetCallback);
      }
    }
    function checkCompletion(){
      var complete = $filter('memory')($scope.cards,"complete");
      if(complete.length < $scope.cards.length) return false;
      $scope.checking = true;
      $rootScope.$emit("audio","Win_Game");
      var evt = {
                eventCategory: "GRTT: Mini Game",
                eventLabel:  "GRTT: " + $scope.currentMinigame.title
            };
      gtag("event", "GRTT: end - complete", evt);

      $timeout(function(){
        $scope.setGeocacheCallback(win);
        },$scope.MEMORY_DELAY);

    }
    function win(){
       // 
          var deferred = $q.defer();
          deferred.promise.then(returnToMenu);
          $scope.currentLocation.isCorrect = true;
          $scope.setCurrentArtifact($scope.currentLocation.artifact,deferred);
       // 
    }

  	function onMinigameSelection(value){
  		if(!value) return;
  		if(value.type !== "psychic-memory") return;

      reset();
  	}

    function reset(){
      if(!$rootScope.MemoryHelpView){
        $rootScope.MemoryHelpView = true;
        $scope.help();
      }
      $scope.checking = false;
      $scope.cards = angular.copy($scope.currentMinigame.cards);
      $scope.maxAttempts = $scope.currentMinigame.maxattempts;
      $scope.numAttempts = 0;
      $scope.updateTelepathy(0);

      var evt = {
          eventCategory: "GRTT: Mini Game",
          eventLabel:  "GRTT: " + $scope.currentMinigame.title
      };
      gtag("event", "GRTT: start", evt);

      randomize();
    }

    function randomize(){
      for(var i = 0, count = $scope.cards.length; i < count; i++){
        $scope.cards[i].randomIndex = Math.random();
        $scope.cards[i].selected = false;
      }
      $scope.cards.sort(sortCards);
    }

    function returnToMenu(){
      $scope.setCurrentPage($scope.currentLocation.isCorrect ? $scope.PAGE_ARTIFACT_COLLECTION : $scope.PAGE_MAP);
    }
    function sortCards(a,b){
      return (a.randomIndex > b.randomIndex) ? 1 : -1;
    }

  });
